export const debugMode = false;
export const trialMode = false;

export const hideMagies = false;

export const dashboardDomain = (debugMode)?'http://newlook.essentialskills.com/':(trialMode)?'https://trial.essentialskills.com/':'https://online.essentialskills.com/';
export const resourceDomain = (trialMode)?'https://learningtrial.essentialskills.com/':'https://media.essentialskills.com/';
export const altDomain = 'https://alt1.essentialskills.com/';

export const getLogoutDomain = ()=>{

    if (trialMode){
        if(sessionStorage.getItem('logoutDomain'))
            return 'https://trial.essentialskills.com/'+sessionStorage.getItem('logoutDomain')+'/';
        return 'https://trial.essentialskills.com/';
    }

    if(sessionStorage.getItem('custID') && sessionStorage.getItem('custID').toUpperCase().startsWith("NYC"))
        return 'https://online.essentialskills.com/nyclogout.php';

    if(sessionStorage.getItem('logoutDomain'))
        return 'https://online.essentialskills.com/'+sessionStorage.getItem('logoutDomain')+'/';

    return 'https://online.essentialskills.com/';
};

export const getCreateFeildStatus = (fieldName, password, isRequired) =>{
    if(isRequired && password ==='') return {error:`${fieldName} requires a value`}; // check is the column is empty ''
    if(!isRequired && password ==='') return {};

    if(!(/^[^;/?:&=+$,#_]+$/.test(password))) // checking for illegal characters
        return {error:`${fieldName} contains invalid characters`};
    return {};
};

export const getCreateUserStatus = (fieldName, userItem, isRequired, takenList, notCaseSensitive) =>{
    if(isRequired && !userItem) return {error:`${fieldName} requires a value`}; // check is the column is empty ''

    if(!(/^[^;/?:@&=+$,#_]+$/.test(userItem))) // checking for illegal characters
        return {error:`${fieldName} contains invalid characters`};

    let duplicateCount = 0;
    if(notCaseSensitive){
        takenList.forEach(e=> { (e===userItem) && duplicateCount++; });
    }
    else{
        takenList.forEach(e=> { (e.toUpperCase()===userItem.toUpperCase()) && duplicateCount++; });
    }
    if (duplicateCount > 0) return {error:`${fieldName} already taken`};

    return {};
};

export const generatePassword = (length, hasLetters, hasNumber) =>{
    let possible = ((hasLetters)?'abcdefghijklmnopqrstuvwxyz':'') + ((hasNumber)?'0123456789':'');
    let text = '';
    for (var i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    if(blackListed(text))
        text = generatePassword(length, hasLetters, hasNumber);
    return text;
};

const blackList = ['anus','anal','arse','clit','cock','cunt','crap','dago','damn','dick','dike','dyke','fart','fuck','gook','heeb','hell','homo','jizz','kike','kunt','kyke','muff','paki','piss','poop','poon','puto','shit','shiz','slut','smeg','spic','tard','tits','twat','wank'];

const blackListed = text =>{
    if (blackList.includes(text))
        return true;
    return false;
};

export const properName=(name)=> {
    if(typeof name == 'undefined' || name=='')
        return '';

    // don't need this anymore...
    return name.toLowerCase();

    // return ('' + name.replace(/[^\s\-\']+[\s\-\']*/g, function(word) {
    //     return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
    // }).replace(/\b(Van|De|Der|Da|Von)\b/g, function(nobiliaryParticle) {
    //     return nobiliaryParticle.toLowerCase();
    // }).replace(/Mc(.)/g, function(match, letter3) {
    //     return 'Mc' + letter3.toUpperCase();
    // }));
};
    // let possible = '';
    // possible += (hasLetters)?'abcdefghijklmnopqrstuvwxyz':'';
    // possible += (hasNumber)?'0123456789':'';

export const setupDatabase=(dataPathID)=>{
    const convertIDToProductionPath=(id)=>{
        const productions = ['Dev', 'Live', 'Beta', 'Trial', 'Preview'];
        const projects = ['LessonBuilder'];
        const databases = ['DynamoDB', 'MySQLDB', 'AuroraDB'];
        const regions = ['AWS:us-east-1','AWS:ca-central-1'];
        const APIs =['Default API','Lambda', 'PHP', 'Node'];
    
        const productionIDs = ['81d9','1551','1fe1','f2f5','6cd9'];
        const projectIDs = ['7f23'];
        const databaseIDs = ['202e','f1a9','6942'];
        const regionIDs= ['aea8','zf5d'];
        const apiIDs = ['0000','d610','91a9','ba05'];

        const pathParts = id.match(/.{1,4}/g); 

        let productionData={
            production: productions[productionIDs.indexOf(pathParts[0])],
            projects: projects[projectIDs.indexOf(pathParts[1])],
            databaseType: databases[databaseIDs.indexOf(pathParts[2])],
            region: regions[regionIDs.indexOf(pathParts[3])],
            APIType: APIs[apiIDs.indexOf(pathParts[4])],
            APIURL:''
        };

        // OVERRIDE API type if its not hardcoded
        let APIType = (productionData.APIType === 'Default API') ? 'Lambda' : productionData.APIType;

        if(APIType === 'Lambda' && productionData.region === 'AWS:us-east-1'){ 
            if(productionData.production === 'Dev') productionData.APIURL = 'https://m09jf6n9m1.execute-api.us-east-1.amazonaws.com/default/v7rest';
            if(productionData.production === 'Live') productionData.APIURL = 'https://44lzk5zna1.execute-api.us-east-1.amazonaws.com/default/LessionBuilder_Live';
            if(productionData.production === 'Beta') productionData.APIURL = 'https://l047fi91fg.execute-api.us-east-1.amazonaws.com/default/lessonbuilder_beta';
        }
        if(APIType === 'Node' && productionData.region === 'AWS:us-east-1')
            productionData.APIURL = 'http://v7nodeapi.essentialskills.com:1337/api/query';
        if(APIType === 'PHP' && productionData.region === 'AWS:us-east-1')
            productionData.APIURL = 'http://v7phpapi.essentialskills.com/aws.php';

        if(productionData.projects === 'LessonBuilder' && productionData.production === 'Dev')
            productionData.CONTENTURL = 'http://ess.lesson.dev.content.s3.amazonaws.com';
        if(productionData.projects === 'LessonBuilder' && productionData.production === 'Live')
            productionData.CONTENTURL = 'http://ess.lesson.live.content.s3.amazonaws.com';
        if(productionData.projects === 'LessonBuilder' && productionData.production === 'Beta')
            productionData.CONTENTURL = 'http://ess.lesson.beta.content.s3.amazonaws.com';              
            
        return productionData;
    };

    if(!dataPathID || dataPathID === '0000000000000000')
        return { api: '', type: ''};
    
    const productionPath = convertIDToProductionPath(dataPathID);
 
    return {
        api: productionPath.APIURL,
        contentURL: productionPath.CONTENTURL,
        type: productionPath.databaseType,
        id: dataPathID
    };
};